import Alpine from "alpinejs";
import {
    getUserData,
    createUserDataObjectFromPDVPage,
    setUserDataShop
} from '../../helpers/user'

document.addEventListener('alpine:init', () => {
    Alpine.data('singlePDV', () => {
        return {
            storeDatas(telephone: any, zip: any, city: string, address: string, name: string, code: string, slug: string, latitude: string, longitude: string) {
                const userData = getUserData();
                if(userData === null || userData.shop === null) {
                    const userData = createUserDataObjectFromPDVPage(telephone, zip, city, address, name, code, slug, latitude, longitude);
                    if (userData.shop) {
                        setUserDataShop(userData.shop.phone, userData.shop.zip, userData.shop.city, userData.shop.address, userData.shop.name, userData.shop.clientNumber, userData.shop.url, userData.shop.latitude, userData.shop.longitude);
                    }
                }
            },
        }
    })
})
